import React from 'react';
import { FiStar } from 'react-icons/fi';
import './StarRating.css';

const StarRating = ({ rating = 0, maxRating = 5, size = 20, showValue = false }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0 && rating % 1 >= 0.5;
  const emptyStars = maxRating - fullStars - (hasHalfStar ? 1 : 0);

  // Create star SVG for filled stars
  const StarSVG = ({ filled, className, size }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      fill={filled ? '#ffd700' : 'none'}
      stroke={filled ? '#ffd700' : '#e0e0e0'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  );

  return (
    <div className="star-rating">
      {Array.from({ length: fullStars }).map((_, index) => (
        <StarSVG
          key={`full-${index}`}
          filled={true}
          className="star filled"
          size={size}
        />
      ))}
      {hasHalfStar && (
        <StarSVG
          key="half"
          filled={true}
          className="star half"
          size={size}
        />
      )}
      {Array.from({ length: emptyStars }).map((_, index) => (
        <StarSVG
          key={`empty-${index}`}
          filled={false}
          className="star empty"
          size={size}
        />
      ))}
      {showValue && (
        <span className="rating-value">{rating.toFixed(1)} / {maxRating}</span>
      )}
    </div>
  );
};

export default StarRating;
